import { Skeleton } from "@/components/ui/skeleton";

/**
 * Lightweight skeleton matching the EmployeeDashboard layout.
 * Used as Suspense fallback so the route shows structured content
 * immediately instead of a blank PageLoader on mobile.
 */
export function EmployeeDashboardSkeleton() {
  return (
    <div
      className="min-h-screen w-full bg-ambient text-foreground animate-in fade-in duration-fast"
      data-tint="brand"
      aria-busy="true"
      aria-live="polite"
    >
      <span className="sr-only">Chargement de votre planning...</span>
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6 lg:px-8 py-6 lg:py-8">
        <div className="space-y-5">
          {/* Header */}
          <div className="flex items-center justify-between gap-3">
            <div className="space-y-2 flex-1">
              <Skeleton className="h-3 w-24 rounded-full opacity-70" />
              <Skeleton className="h-7 w-56 rounded" />
            </div>
            <Skeleton className="h-9 w-9 rounded-lg" />
          </div>

          {/* Week navigation */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-9 w-9 rounded-lg" />
            <Skeleton className="h-5 w-40 rounded" />
            <Skeleton className="h-9 w-9 rounded-lg" />
          </div>

          {/* Day cards */}
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                className="rounded-2xl bg-card border border-border/70 shadow-soft p-4 flex items-center gap-3"
              >
                <Skeleton className="h-12 w-12 rounded-xl" />
                <div className="flex-1 space-y-1.5">
                  <Skeleton className="h-4 w-32 rounded" />
                  <Skeleton className="h-3 w-44 rounded opacity-70" />
                </div>
                <Skeleton className="h-6 w-16 rounded-full opacity-70" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
